import { useState, useRef, useEffect } from "react";
import { createLike, deleteLike } from "../services/postService";

function useLike() {
  const [animateHeart, setAnimateHeart] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const updateLikes = async (isLiked, setIsLiked, setLikes, postId, userId) => {
    const nextLiked = !isLiked;
    setIsLiked(nextLiked);
    setLikes((likes) => Math.max(0, likes + (nextLiked ? 1 : -1)));
    try {
      if (isLiked) {
        await deleteLike(postId, userId);
      } else {
        await createLike(postId, userId);
        setAnimateHeart(true);
      }

      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setAnimateHeart(false), 1500);
    } catch (error) {
      setIsLiked(isLiked);
      setLikes((likes) => Math.max(0, likes + (nextLiked ? -1 : 1)));
      console.error("Error liking or disliking post:", error);
      throw error;
    }
  };

  return {
    animateHeart,
    updateLikes,
  };
}

export { useLike };
